import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bag-2, luggage, buggage "} maskId="square-filled-radius-0-stroke-1-IconBag2"><path fillRule="evenodd" clipRule="evenodd" d="M16.498 3H7.49805V7H8.4978V20.75H7.4978L7.49805 7H2V21H21.9978V7H16.498V3ZM16.498 7H15.498V4H8.49805L8.4978 7H15.498L15.4978 20.75H16.4978L16.498 7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBag2;
